
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/my-utmb/my-rewards",
      function () {
        return require("private-next-pages/my-utmb/my-rewards/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/my-utmb/my-rewards"])
      });
    }
  